// NOTE: NSAI-5511 — the lookup tables of `schema/zod-error-messages.ts`, the map
// that keeps zod 3's English default messages on zod 4.

export const UUID_FORMATS: ReadonlySet<string> = new Set([
  "uuid",
  "uuidv4",
  "uuidv6",
  "uuidv7",
  "guid",
]);

export const IP_FORMATS: ReadonlySet<string> = new Set(["ipv4", "ipv6"]);

export const CIDR_FORMATS: ReadonlySet<string> = new Set(["cidrv4", "cidrv6"]);

// NOTE: string formats zod 3 validated and named in its message as-is
// ("Invalid email", "Invalid url", ...).
export const NAMED_FORMATS: ReadonlySet<string> = new Set([
  "email",
  "url",
  "emoji",
  "nanoid",
  "cuid",
  "cuid2",
  "ulid",
  "datetime",
  "date",
  "time",
  "duration",
  "base64",
  "base64url",
  "jwt",
]);

// NOTE: zod 4 says "int" where zod 3 said "integer"; a tuple and a record are
// reported against the container type zod 3 named.
export const EXPECTED_TYPE_NAMES: Readonly<Record<string, string>> = {
  int: "integer",
  tuple: "array",
  record: "object",
};
